import * as React from 'react'
import CollapsableCard, { CollapsableCardBody, CollapsableCardHeader } from '../../../components/CollapsableCard/CollapsableCard'
import { BELLRINGER_QUESTION_NUMBERS, BELLRINGER_TABLE_WEEK_NUMBERS } from '../../../services/bellringers'
import { NOT_SPECIFIED } from '../../../constants'
import { TeacherStore } from '../../../stores/teacher.store'

/**
 * This is called grades view but basically shows the BR question sets
 */
export default function GradesViewForTeacher({ subject, grade, key, setNumber, periods, stats, title, ribbonColor = "darkPurple", headerColor = "#279ed7", collapsed = true, onQuestionClick }) {
    let data = {}
    let hasData = stats && stats.length > 0

    return (
        <CollapsableCard key={key} initiallyCollapsed={collapsed}>
            <CollapsableCardHeader>
                <div className="lesson-list-card-header">
                    <span className={`ribbon ${ribbonColor}`}>
                        <span className="bellringers-grade-level">{setNumber}</span>
                    </span>
                    <h2 className="lesson-list-card-header--text">{title}</h2>
                </div>
            </CollapsableCardHeader>

            <CollapsableCardBody> 
                {hasData ? 
                    <BellringerTable subject={subject} setNumber={setNumber} periods={periods} stats={stats} onQuestionClick={onQuestionClick}/>
                    :
                    <div className="mb-3"><h6 className="subcategory-title">NO QUESTIONS ANSWERED YET.</h6></div>
                }
            </CollapsableCardBody>
        </CollapsableCard>
    )
}

function getFilteredStats(stats, setNumber, subject, week, period, ) {
    return stats.filter(d => d.setNumber === setNumber && d.subject === subject && d.week === week && d.period === period)
}

function getQuestionStats(stats, questionNumber) {
    return stats.find(s => s.questionNumber === questionNumber)
}

function getAverageInfoFromQuestionStats(questionStats) {
    if (!questionStats) return ""
    return `${Math.round(100*questionStats.scoreAverage)}%`
}

function getWeeklyStats(stats, setNumber, subject, week) {
    let foundAny = stats.find(d => d.setNumber === setNumber && d.subject === subject && d.week === week)
    return foundAny
}

/**
 * In some schools period is just a number/number string, and in others it could be textual info.
 * 
 * @param period 
 * @returns 
 */
function getPeriodInfo(period: number | string) {
    if (!period) return NOT_SPECIFIED
    
    let isNumber = !isNaN(Number(period))
    if (isNumber) {
        return `Period ${period}`
    }
    return period
}

export function BellringerTable({ subject, setNumber, periods, stats, onQuestionClick }) {
    let weeks = BELLRINGER_TABLE_WEEK_NUMBERS
    let questions = BELLRINGER_QUESTION_NUMBERS

    return (
        <table>
            <thead>
                <tr>
                    <th>Week</th>
                    {periods.map((period) => { 
                        let periodInfo = getPeriodInfo(period)
                        return (
                            <th key={period}>
                                {periodInfo}
                            </th>
                        )}
                    )}
                </tr>
            </thead>

            <tbody>
                {weeks.map(week => {
                    let weeklyStats = getWeeklyStats(stats, setNumber, subject, week)

                    if (!weeklyStats || weeklyStats.length === 0) return ""

                    let lessonName = TeacherStore.getBellringersWeeklyLessonName(subject, setNumber, week)

                    return (
                        <tr key={week}>
                            <td>
                                Week {week}
                                <br/>
                                <span className="bellringers-weekly-lesson-name">{lessonName}</span>
                            </td>
                            {periods.map((period) => {
                                let periodStats = getFilteredStats(stats, setNumber, subject, week, period)
                                return (
                                    <td key={`${week}-${period}`}>
                                        {questions.map(questionNumber => {
                                            let questionStats = getQuestionStats(periodStats, questionNumber)
                                            let {bellringerId} = questionStats || {}
                                            let averageInfo = getAverageInfoFromQuestionStats(questionStats)
                                            let buttonDisabled = !averageInfo
                                            let levelOfDifficulty = TeacherStore.getBellringerLevelOfDifficulty(bellringerId)

                                            return (
                                                <div className="bellringers-questions-stats">
                                                    <div className="d-flex flex-inline align-items-center">
                                                        <div className="bellringers-subjectview-qnum d-flex flex-inline align-items-center">
                                                            Q{questionNumber}: {averageInfo}
                                                        </div>
                                                        {averageInfo &&
                                                            <button
                                                                className="btn-bellringers-question-review"
                                                                onClick={e => onQuestionClick(bellringerId, period)}
                                                                disabled={buttonDisabled}>
                                                                    <img
                                                                        className="explanation-button-image m-0"
                                                                        src={`/assets/images/icons/v2/ico-modal.svg`}
                                                                        width="18"
                                                                        height="18"
                                                                        alt=""
                                                                    />
                                                            </button>
                                                        }
                                                    </div>
                                                    {averageInfo &&
                                                        <div className="bellringer-question-level-of-difficulty">
                                                            ({levelOfDifficulty})
                                                        </div>
                                                    }
                                                </div>
                                            )
                                        })}
                                    </td>
                                )
                            })}
                        </tr>
                    )}
                )}
            </tbody>
        </table>
    )
}
